import { Col, Row } from 'react-bootstrap';
import { setFullLoading } from '../../store/appSlice';
import { useDispatch, useSelector } from 'react-redux';
import { apiGet } from '../../apis';
import 'react-lazy-load-image-component/src/effects/blur.css';
import { ProductLazyLoadImg } from '../../components/user/ProductImg';
import { useMsal } from '@azure/msal-react';
import { language } from '../../language';
import Swal from 'sweetalert2';
import { outOfStockSwal } from '../../helpers/swal/cart';

const ProductItems = (props) => {
  const { instance, accounts } = useMsal();
  const dispatch = useDispatch();
  const hrMobileLanguage = useSelector((state) => state.app.slsHrMobileLanguage);

  const callProductDetailApi = async (product) => {
    try {
      props?.setCurrentModalProduct(null);
      dispatch(setFullLoading(true));

      const getProduct = await apiGet({
        uri: `Products/Sku?sku=${product?.sku || ''}`,
        msal: {
          instance: instance,
          accounts: accounts,
        },
      });

      props?.setCurrentModalProduct(getProduct);
      props?.setShowDetailModal(true);

      dispatch(setFullLoading(false));
    } catch (error) {
      dispatch(setFullLoading(true));
      console.error(error);
    }
  };

  return (
    <Row className="product-list">
      {props?.products?.map((p, i) => (
        <Col xs={6} md={4} lg={4} xl={3} xxl={3} key={i} className="px-2">
          <div className={`item ${p?.stock <= 0 && 'item-out-of-stock'}`} id={`item-${i}`} onClick={async () => {
            await callProductDetailApi(p);
          }}>
            {p?.stock <= 0 && (
              <span className='badge out-of-stock-product-box'>{language?.homePage?.Cart?.OutOfStock?.[hrMobileLanguage]}</span>
            )}

            <div style={{ position: 'relative' }}>
              {(p?.stock > 0 && (p?.onSale == true || p?.onSale == 'Yes')) && (
                <div className='on-sales-tag-on-img'>
                  <span className="badge fs-10" style={{ backgroundColor: '#dd516e' }}>{language?.homePage?.Filter?.onSales?.[hrMobileLanguage]}</span>
                </div>
              )}

              <ProductLazyLoadImg className={`item-img`} imgId={p?.image} />
            </div>

            <Row className=''>
              <Col xs={10}>
                <h5 className='m-0 px-2' style={{ fontWeight: 'bold' }}>{p?.price?.toLocaleString('en-US') || 0} ฿</h5>
                <p className='d-inline-block text-truncate m-0 mt-1 px-2' style={{ maxWidth: '90%' }}>{p?.productName}</p>
              </Col>
              <Col xs={2}>
                <div style={{ float: 'right' }}>
                  <div className='add-to-cart-icon' data-cy={`add-to-cart-icon-${i}`} onClick={async (e) => {
                    e.preventDefault();
                    e.stopPropagation();

                    if (p?.hasChild && p?.size?.toLowerCase() != 'one size') {
                      return await callProductDetailApi(p);
                    }

                    if (p?.stock <= 0) {
                      return Swal.fire(outOfStockSwal);
                    }

                    await props?.callAddToCartApi({ sku: p?.sku, stock: p?.stock }, {});
                  }}>
                    <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect opacity="0.05" x="1" y="1" width="40" height="40" rx="20" stroke="black" />
                      <rect x="15" y="20" width="12" height="2" rx="1" fill="black" />
                      <path fillRule="evenodd" clipRule="evenodd" d="M22 15.75V26.25C22 26.6642 21.5523 27 21 27C20.4477 27 20 26.6642 20 26.25V15.75C20 15.3358 20.4477 15 21 15C21.5523 15 22 15.3358 22 15.75Z" fill="black" />
                    </svg>

                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Col>
      ))}
    </Row>
  );
};

export default ProductItems;
